export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12778.09dfb402.jpg";